/* Lazy-loads Google reCAPTCHA v3 and resolves a per-action token. v3 scores
   behavior invisibly (no checkbox), so it blocks scripted mass-registration
   without adding friction for a real person registering many people in one
   sitting — unlike the per-IP rate limit it replaces on /auth/register. */

const SITE_KEY = '6Ld-KvMtAAAAAFrdtQBngLbr_xUiS88RTpifXtcS';

let loadPromise = null;

const loadScript = () => {
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha) { resolve(); return; }
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('recaptcha script failed to load'));
    document.head.appendChild(script);
  });
  return loadPromise;
};

export const getRecaptchaToken = async (action) => {
  try {
    await loadScript();
    return await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(SITE_KEY, { action }).then(resolve).catch(() => resolve(null));
      });
    });
  } catch (e) {
    return null;
  }
};
